export const mobileConstants = {
    actionBarHeight: 45,
    drawerWidth: 240,
};